import React from 'react';
import { colors } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';
import GlobeIllustration from 'svg/illustrations/Globe';
import { legalmenteForegroundOnPage } from '../legalmenteReadableText';

const Benefits = () => {
  const theme = useTheme();
  const headingColor = legalmenteForegroundOnPage(theme);
  const sections = [
    {
      title: 'Escolaridad y prevención',
      subtitle:
        'Acoso escolar, protocolos de mediación y manuales de convivencia. Ideal para colegios y universidades.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 14l9-5-9-5-9 5 9 5z M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"
          />
        </svg>
      ),
      color: colors.blueGrey,
    },
    {
      title: 'Salud y bienestar integral',
      subtitle:
        'Derechos de niños, niñas y adolescentes; herramientas legales para cuidadores y protección médica. Ideal para clínicas y aseguradoras.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
          />
        </svg>
      ),
      color: colors.green,
    },
    {
      title: 'Seguridad patrimonial y familiar',
      subtitle:
        'Resolución de conflictos, disolución matrimonial y protección en entornos digitales. Ideal para banca y asesoría financiera.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
          />
        </svg>
      ),
      color: colors.brown,
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium', color: headingColor }}
          gutterBottom
          align="center"
        >
          Territorios de contenido
        </Typography>
        <Box
          component={Typography}
          sx={{ fontWeight: 700, fontFamily: 'Georgia, "Times New Roman", serif', color: headingColor }}
          variant="h3"
          gutterBottom
          align="center"
        >
          Premium alineado a tu categoría
        </Box>
        <Typography align="center" color="textSecondary" variant="h6">
          Tres pilares editoriales para conectar patrocinio con contexto real: prevención, salud y patrimonio familiar.
        </Typography>
      </Box>
      <Box display="flex" justifyContent="center" alignItems="center" marginBottom={4} data-aos="fade-up">
        <Box maxWidth={300} width="100%">
          <GlobeIllustration width="100%" height="100%" />
        </Box>
      </Box>
      <Grid container spacing={4}>
        {sections.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              height={1}
              display="flex"
              flexDirection="column"
              data-aos="fade-up"
              data-aos-delay={i * 100}
            >
              <Box display="flex" justifyContent="flex-start" alignItems="center" marginBottom={2}>
                <Box
                  component={Avatar}
                  width={60}
                  height={60}
                  marginRight={2}
                  bgcolor={item.color[50]}
                  color={item.color[900]}
                >
                  {item.icon}
                </Box>
                <Box>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
                    {item.title}
                  </Typography>
                </Box>
              </Box>
              <Typography color="textSecondary">{item.subtitle}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Benefits;
